import React from 'react';
import { ArticlePage, ArticleTypes } from './models';

interface Props {
	article: ArticlePage;
	setVideo: any;
	showDatesAndCategory: boolean;
}

export const ArticleCardView = (props: Props) => {
	const { article, setVideo, showDatesAndCategory } = props;

	const onClick = () => {
		setVideo(article?.videoUrl);
	};

	const renderLinkIcon = (articleType: string) => {
		switch (articleType) {
			case ArticleTypes.PDF:
				return <svg className='link-icon' focusable='false' aria-hidden='true' style={{ width: '1em', height: '1em', marginLeft: '0.25em', verticalAlign: 'middle', display: 'inline-block' }}>
					<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#pdf-icon-mui' />
				</svg>;
			case ArticleTypes.ExternalLink:
				return <svg className='link-icon' focusable='false' aria-hidden='true' style={{ width: '1em', height: '1em', marginLeft: '0.25em', verticalAlign: 'middle', display: 'inline-block' }}>
					<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#icon-external-link' />
				</svg>;
			default:
				return null;
		}
	};

	const renderMedia = (articleType: string) => {
		switch (articleType) {
			case ArticleTypes.StandardLink:
				return <img src={article?.thumbnail} alt={article?.altText} />
			case ArticleTypes.ExternalLink:
				return <img src={article?.thumbnail} alt={article?.altText} />
			case ArticleTypes.Article:
				return <img src={article?.thumbnail} alt={article?.altText} />
			case ArticleTypes.Video:
				return <><img src={article?.thumbnail} alt={article?.altText} /><button type='button' className='topic-grid-item-video-button' onClick={onClick}><svg focusable='false' className='svg-icon'>
					<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#play-icon' />
				</svg><span className='visually-hidden'>Play button</span></button></>
			case ArticleTypes.PDF:
				return <img src={article?.thumbnail} alt={article?.altText} />
			case ArticleTypes.Event:
				return <img src={article?.thumbnail} alt={article?.altText} />
			case ArticleTypes.ELearningCourse:
				return <img src={article?.thumbnail} alt={article?.altText} />
			case ArticleTypes.LandingPage:
				return <img src={article?.thumbnail} alt={article?.altText} />
		}
	};
	return (
		<div className='topic-grid-item'>
			<div className='topic-grid-item-preheader'>
				{showDatesAndCategory && article?.date && <p className='topic-grid-item-preheader-text'>{article?.date}</p>}
				{showDatesAndCategory && <p className='topic-grid-item-preheader-text'>{article?.category}</p>}
			</div>
		<div className='topic-grid-item-image'>
			{renderMedia(article?.articleType)}
		</div>

		<h5><strong><a href={article?.pdfUrl || article?.externalUrl || article?.pageUrl} target={article?.pdfUrl || article?.externalUrl ? '_blank' : '_self'} >{article?.articleTitle}{renderLinkIcon(article?.articleType)}</a></strong></h5>
		<p><a href={article?.pdfUrl || article?.externalUrl || article?.pageUrl} target={article?.pdfUrl || article?.externalUrl ? '_blank' : '_self'} >{article?.subTitle}</a></p>

		<div
				dangerouslySetInnerHTML={{ __html: article?.description }}
				className='rich-text topic-grid-item-description'
				aria-label='cms-content'
			/>

		</div>
	);

};